<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0">
  <link rel="stylesheet" href="//cdnjs.cloudflare.com/ajax/libs/font-awesome/3.1.0/css/font-awesome.min.css" />
  </head>

  <body>
    <div class="page ">
      <div class="d-flex justify-content-center">
        <h5 id="heading" class="text-light" style="font-size: 12px;">Informations du fiche {{data.name}}</h5>
        <button type="button"  class="btn btn-link position-absolute" style="top: 10px; right: 10px;" aria-label="Close" (click)="closeModal()" >
          <i class="fas fa-times text-light" style="font-size: 1.5rem; "></i>
        </button>
      </div>
       <!-- tabs -->
       <div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
         <!-- <input type="radio" name="pcss3t" checked  id="tab1"class="tab-content-first">
         <label for="tab1">Elements du dossier</label>

         <input type="radio" name="pcss3t"   id="tab2"class="tab-content-2">

         <label for="tab2">identification parties prenantes</label> -->
         <input type="radio" name="pcss3t" checked   id="tab1"class="tab-content-first">

         <label for="tab1">Jugement</label>

         <input type="radio" name="pcss3t" id="tab2" class="tab-content-2">
         <label for="tab2">Informations pérsonnelles</label>

         <input type="radio" name="pcss3t" id="tab3" class="tab-content-3">
         <label for="tab3"><i ></i>Décision</label>
         <input type="radio" name="pcss3t" id="tab4" class="tab-content-4">
         <label for="tab4"><i ></i>Piéces d'éxecutions</label>

         <ul>
           <li class="tab-content tab-content-first typography" style="overflow: auto;">
            <br>


            <fieldset><br><br>

              <div class="form-card">
                <div class="d-flex flex-column flex-md-row justify-content-between text-center mb-3">
                    <div class="flex-fill mb-2 mb-md-0" style="padding: 0 5px 0 0;">
                        <label class="fieldlabels">Numéro jugement:</label>
                        <input class="form-control" type="text" value="{{data.numero_du_jugement}}" name="numero_jugement" />
                    </div>
                    <div class="flex-fill mb-2 mb-md-0" style="padding: 0 5px 0 0;">
                        <label class="fieldlabels">Date jugement:</label>
                        <input class="form-control" type="text" value="{{getFormattedDate(data.date_du_jugement)}}" name="datejugement" />
                    </div>
                    <div class="flex-fill">
                        <label class="custom-file-upload" for="file2" (click)="openModalVisualDoc(data.jugement_file)">
                            <div class="icon">
                                <i class="fas fa-regular fa-file"></i>
                            </div>
                            <div class="text text-nowrap">
                                <span class="file-label">Voir Fichier Join</span>
                            </div>
                        </label>
                    </div>
                </div>
            
                <div class="d-flex flex-column flex-md-row justify-content-between" >
                    <div class="col-md-7 col-sm-12 d-flex flex-column" style="margin: 0 10px 0 0;" >
                        <div class="bg-dark text-light text-center mb-2">Liste des réglements</div>
                        <div class="table-responsive">
                          <table id="myTable" class="table table-striped text-center col-md-12 col-sm-12" >
                              <thead class="bg-secondary text-light">
                                  <tr class="text-nowrap">
                                      <th>Réglement</th>
                                      <th>Date</th>
                                      <th>Signifié à</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr *ngFor="let reglement of Reglements" class="text-nowrap">
                                      <td class="text-nowrap">
                                          <select class="custom-select" name="reglement" required>
                                              <option value="{{reglement.reglement}}">{{reglement.reglement}}</option>
                                              <option value="Réputé contradictoire">Réputé contradictoire</option>
                                              <option value="Itératif défaut">Itératif défaut</option>
                                              <option value="Sur opposition à jugement en date du">Sur opposition à jugement en date du</option>
                                              <option value="Contradictoire">Contradictoire</option>
                                          </select>
                                      </td>
                                      <td>
                                          <input type="text" class="form-control" name="date" [value]="getFormattedDate(reglement.date) || null" />
                                      </td>
                                      <td>
                                          <input type="text" class="form-control" name="signifie_a" [value]="reglement.signifie_a || null" />
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                      
                    </div>
            
                    <div class="col-md-5 col-sm-12 text-center">
                        <div class="bg-dark text-light text-center mb-2">Liste des infractions</div>
                        <div class="table-responsive">
                          <table class="table table-striped text-center col-md-12 col-sm-12" style="font-size: 11px;">
                              <thead class="bg-secondary text-light">
                                  <tr class="text-nowrap">
                                      <th scope="col">Libellé</th>
                                  </tr>
                              </thead>
                              <tbody class="text-nowrap">
                                  <ng-container *ngIf="Infractions.length > 0; else noData" >
                                      <tr *ngFor="let selectedInfraction of Infractions " class="text-nowrap">
                                          <td>{{ selectedInfraction.nature }}</td>
                                      </tr>
                                      <!-- <pagination-controls  (pageChange)="pageinf = $event" previousLabel="" nextLabel=""
                                                responsive="true" [id]="'infr'"></pagination-controls> -->
                                  </ng-container>
                                  <ng-template #noData>
                                      <tr>
                                          <td colspan="1" class="text-center">Aucune donnée disponible</td>
                                      </tr>
                                  </ng-template>
                              </tbody>
                          </table>
                      </div>
                      
                    </div>
                </div>
            </div>
            
          </fieldset>
           </li>

           <li class="tab-content tab-content-2 typography" style="overflow: auto;height: 450px;">
             <br>
             <fieldset>
              <div class="form-card">
                <div class="row">
                    <div class="col-12 col-md-6 mb-3" style="padding: 0 5px 0 0;">
                        <label class="fieldlabels">Type d'identification</label>
                        <input class="form-control" type="text" name="type_identification" value="{{data.type_didentification}}" />
                        
                        <label class="fieldlabels">Genre:</label>
                        <input class="form-control" type="text" name="genre" value="{{data.genre}}" />
            
                        <label class="fieldlabels">Nom:</label>
                        <input class="form-control" type="text" name="nom" value="{{data.nom}}" />
            
                        <label class="fieldlabels">Prénom:</label>
                        <input class="form-control" type="text" name="prenom" value="{{data.prenom}}" />
            
                        <label class="fieldlabels">Nationalités:</label>
                        <input class="form-control" type="text" name="nationalites" value="{{data['nationalités']}}" />
            
                        <label class="fieldlabels">Date de naissance:</label>
                        <input class="form-control" type="text" name="date_de_naissance" value="{{data.date_de_naissance}}" />
            
                        <label class="fieldlabels">Profession:</label>
                        <input class="form-control" type="text" name="profession" value="{{data.profession}}" />
                    </div>
            
                    <div class="col-12 col-md-6 mb-3" style="padding: 0 5px 0 0;">
                        <label class="fieldlabels">Numéro d'identification:</label>
                        <input class="form-control" type="text" name="numéros_didentification" value="{{data['numéros_didentification']}}" />
            
                        <label class="fieldlabels">Pays de résidence:</label>
                        <input class="form-control" type="text" name="pays_de_residence" value="{{data.residence}}" />
            
                        <label class="fieldlabels">Résidence:</label>
                        <input class="form-control" type="text" name="residence" value="{{data.residence}}" />
            
                        <label class="fieldlabels">Affiliation:</label>
                        <table class="table table-striped table-bordered">
                            <tbody>
                                <tr>
                                    <td>
                                        <label class="fieldlabels">Nom de la mère:</label>
                                        <input class="form-control" type="text" name="nom_mere" value="{{nom_mere}}" />
                                    </td>
                                    <td>
                                        <label class="fieldlabels">Prénom de la mère:</label>
                                        <input class="form-control" type="text" name="prenom_mere" value="{{prenom_mere}}" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label class="fieldlabels">Nom du père:</label>
                                        <input class="form-control" type="text" name="nom_pere" value="{{nom_pere}}" />
                                    </td>
                                    <td>
                                        <label class="fieldlabels">Prénom du père:</label>
                                        <input class="form-control" type="text" name="prenom_pere" value="{{prenom_pere}}" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
            
                        <label class="fieldlabels">Statut matrimonial:</label>
                        <input class="form-control" type="text" name="status_matrimoniale" value="{{data.status_matrimoniale}}" />
                    </div>
                </div>
            </div>
            
          </fieldset>
            </li>



          <li class="tab-content tab-content-3 "><br>

           <fieldset>

            <div class="form-card">
              <div class="row mb-3">
                  <div class="col-12 col-md">
                      <label class="fieldlabels">Décision judiciaire:</label>
                      <select class="form-select" (change)="UpdateTypeCondamnation($event.target.value)">
                          <option [value]="Decision_Judiciaire">{{ Decision_Judiciaire }}</option>
                          <option *ngFor="let option of TypeDeCondamnation" [value]="option.name">{{ option.name }}</option>
                      </select>
          
                      <!-- <label class="fieldlabels">Catégorie de la décision: *</label>
                      <select class="form-select" (change)="UpdateCategoriCondoamnatione($event.target.value)">
                          <option [value]="Categorie_Decision">{{ Categorie_Decision }}</option>
                          <option *ngFor="let option of CategorieDeCondamnation" [value]="option.name">{{ option.name }}</option>
                      </select> -->
                  </div>
                  <div class="col-12 col-md">
                      <label class="fieldlabels">Date de la décision:</label>
                      <input type="text" class="form-control" [value]="getFormattedDate(data['date_de_la_décision'])" name="date_de_la_décision" />
                  </div>
              </div>
          
              <div class="row mb-3">
                  <div class="col shadow">
                      <label class="fieldlabels bg-dark text-light">Contrainte par corps:</label>
                      <div class="container">
                          <table class="table table-striped text-center table-responsive" style="font-size: 10px;">
                              <thead>
                                  <tr>
                                      <th>#</th>
                                      <th>Début</th>
                                      <th>Main levé</th>
                                      <th>Fin</th>
                                      <th>Action</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr *ngFor="let cpc of ContrainteParCorps; let i = index">
                                      <td>{{ i + 1 }}</td>
                                      <td><input type="date" [value]="cpc.debut" class="form-control"></td>
                                      <td><input type="text" [value]="cpc.main_leve" class="form-control"></td>
                                      <td><input type="date" [value]="cpc.fin" class="form-control"></td>
                                      <td><i class="fas fa-solid fa-arrow-up text-success"></i></td>
                                  </tr>
                                  <tr *ngFor="let ligne of lignes; let i = index">
                                      <td>{{ ligne.id }}</td>
                                      <td><input type="date" [(ngModel)]="ligne.debut" class="form-control"></td>
                                      <td><input type="date" [(ngModel)]="ligne.fin" class="form-control"></td>
                                      <td><input type="date" [(ngModel)]="ligne.main_leve" class="form-control"></td>
                                      <td><i class="fas fa-solid fa-trash text-danger" (click)="deleteContrainte(ligne)"></i></td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                  </div>
              </div>
          
              <div class="d-flex flex-column col-12 mb-3">
                  <div class="shadow col-12">
                      <label class="fieldlabels bg-dark text-light">Emprisonnements:</label>
                      <table class="table table-striped text-center table-responsive" style="font-size: 10px;">
                          <thead>
                              <tr>
                                  <th>Type</th>
                                  <th>Durée</th>
                                  <th>Périodicité</th>
                                  <th>Action</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let emp of Emprisonements">
                                  <td><input type="text" [value]="emp.type" class="form-control"></td>
                                  <td><input type="text" [value]="emp['durée']" class="form-control"></td>
                                  <td><input type="text" [value]="emp['périodicité']" class="form-control"></td>
                                  <td><i class="fas fa-solid fa-arrow-up text-success"></i></td>
                              </tr>
                              <tr *ngFor="let ligne of lignes_condamenations">
                                  <td>
                                      <select class="form-select" [(ngModel)]="ligne.type">
                                          <option *ngFor="let option of optionsSelect" [value]="option">{{ option }}</option>
                                      </select>
                                  </td>
                                  <td><input type="text" placeholder="Durée" [(ngModel)]="ligne['durée']" class="form-control"></td>
                                  <td>
                                      <select class="form-select" [(ngModel)]="ligne['périodicité']">
                                          <option *ngFor="let option of periodicite" [value]="option">{{ option }}</option>
                                      </select>
                                  </td>
                                  <td><i class="fas fa-solid fa-trash text-danger" (click)="deleteEmprisonnement(ligne)"></i></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
          
                  <div class="shadow col-12">
                      <label class="fieldlabels bg-dark text-light">Amendes:</label>
                      <table class="table table-striped text-center table-responsive" style="font-size: 10px;">
                          <thead>
                              <tr>
                                  <th>Montant</th>
                                  <th>Aux dépens liquidés à la somme</th>
                                  <th>Frais de Timbre</th>
                                  <th>Frais d'Enregistrement</th>
                                  <th>Autres Frais</th>
                                  <th>Action</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let amd of Amendes">
                                  <td><input type="number" class="form-control" placeholder="Montant" [value]="amd.montant"></td>
                                  <td><input type="text" class="form-control" placeholder="Dépens liquidés..." [value]="amd.aux_depens_liquides_a_la_somme"></td>
                                  <td><input type="text" class="form-control" placeholder="Timbre" [value]="amd.timbre"></td>
                                  <td><input type="text" class="form-control" placeholder="Frais d'enregistrement" [value]="amd.enregistrement"></td>
                                  <td><input type="text" class="form-control" placeholder="Autres frais" [value]="amd.autrefrais"></td>
                                  <td><i class="fas fa-solid fa-arrow-up text-success"></i></td>
                              </tr>
                              <tr *ngFor="let ligne of lignes_ammendes">
                                  <td><input type="number" class="form-control" placeholder="Montant" [(ngModel)]="ligne.montant"></td>
                                  <td><input type="text" class="form-control" placeholder="Dépens liquidés..." [(ngModel)]="ligne.aux_depens_liquides_a_la_somme"></td>
                                  <td><input type="text" class="form-control" placeholder="Timbre" [(ngModel)]="ligne.timbre"></td>
                                  <td><input type="text" class="form-control" placeholder="Frais d'enregistrement" [(ngModel)]="ligne.enregistrement"></td>
                                  <td><input type="text" class="form-control" placeholder="Autres frais" [(ngModel)]="ligne.autrefrais"></td>
                                  <td><i class="fas fa-solid fa-trash text-danger" (click)="deleteAmmendes(ligne)"></i></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
          

         </fieldset>

        </li>
        <li class="tab-content tab-content-4 ">


          <div class=" text-center mt-4" style="margin-top: 30%;" (click)="openModalVisualCasier(data)">
            <div class="card-statistic-3" style="margin: auto;">
                <div class="card-icon card-icon-large">
                    <i class="fas fa-solid fa-print text-primary" style="font-size: 100px;"></i>
                </div>
                <h5>
                    <span class="badge badge-sm bg-gradient-primary text-wrap" style="background-color: rgb(209, 188, 147);font-size: 12px ;">Cliquez pour visualiser ou imprimer</span>
                </h5>
            </div>
        </div>
        

       </li>

         </ul>

       </div>

       <div class="d-flex justify-content-between" *ngIf="ALLOWED_DECISION_FINAL ==true">
        <div class="col-lg-3 col-sm-3 actionBtn mt-3">
          <div class="addButton  ">
            <div class="button b1  " (click)="UpdateFinalStatus('En appel')">
              <i class="fas fa-solid fa-gavel float-left mt-1" style="font-size: 20px;"></i> Décision en appel </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-3  actionBtn mt-3">
          <div class="addButton  ">
            <div class="button b2  text-light" (click)="UpdateFinalStatus('Definitive')">
              <i class="fas fa-solid fa-gavel float-left mt-1" style="font-size: 20px;"></i> Rendre définitif </div>
          </div>
        </div>
      </div>
     </div>
     <!-- <ngx-ui-loader></ngx-ui-loader> -->
     <ngx-ui-loader></ngx-ui-loader>
  </body>
</html>



